export class HttpException extends Error {
  public readonly code?: number;
  public readonly headers?: Record<string, string>;
  private body?: object;
  private json: object;

  constructor(
    message: string,
    code?: number,
    body?: object,
    headers?: Record<string, string>,
  ) {
    super();
    this.message = message;
    this.code = code;
    this.body = body;
    this.headers = headers;
    this.json = this.tryParseMessage(message);
  }

  tryParseMessage(msg: string) {
    try {
      return JSON.parse(msg);
    } catch (err) {
      return {};
    }
  }

  toString() {
    return `${this.code}: ${this.message}`;
  }
}
